export default __webpack_public_path__ + "static/ceo-d8dacb0c79b42f07577acbd4aa142097.jpg";